import { apiService } from './api';
import { Stakeholder, CreateStakeholderDto, UpdateStakeholderDto, StakeholderQueryParams } from '../types/stakeholder';

export class StakeholderService {
  private readonly basePath = '/api/stakeholders';

  async getStakeholders(params?: StakeholderQueryParams): Promise<{ data: Stakeholder[]; total: number }> {
    const response = await apiService.get(this.basePath, { params });
    return response.data;
  }

  async getStakeholder(id: string): Promise<Stakeholder> {
    const response = await apiService.get(`${this.basePath}/${id}`);
    return response.data;
  }

  async createStakeholder(data: CreateStakeholderDto): Promise<Stakeholder> {
    const response = await apiService.post(this.basePath, data);
    return response.data;
  }

  async updateStakeholder(id: string, data: UpdateStakeholderDto): Promise<Stakeholder> {
    const response = await apiService.put(`${this.basePath}/${id}`, data);
    return response.data;
  }

  async deleteStakeholder(id: string): Promise<void> {
    await apiService.delete(`${this.basePath}/${id}`);
  }

  async mergeStakeholders(sourceId: string, targetId: string, resolvedFields?: Record<string, any>): Promise<Stakeholder> {
    const response = await apiService.post(`${this.basePath}/merge`, {
      sourceId,
      targetId,
      resolvedFields,
    });
    return response.data;
  }

  async uploadProfileImage(stakeholderId: string, file: File): Promise<{ imageUrl: string }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entityType', 'stakeholder');
    formData.append('entityId', stakeholderId);
    
    const response = await apiService.post('/api/media/upload', formData);
    return response.data;
  }
}

export const stakeholderService = new StakeholderService();